export const REQUIERED_FIELDS_LABEL = '(*) Required fields';
